import {
	PartialStateUpdater,
	patchState,
	Prettify,
	signalStore,
	withMethods,
	withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, tap } from 'rxjs';
import { withStorageSync } from '@angular-architects/ngrx-toolkit';

type ChatSettingsSchema = {
    chatSettings: {
        imageModel: 'auto' | 'FLUX.1-Kontext-pro' | 'gpt-image-1.5';
    };
};

export type SettingsState = {
	/**
	 * Color scheme for the application.
	 * 'light' or 'dark' will force the respective color scheme.
	 * 'light dark' will use the preferred color scheme set by browser settings.
	 */
	colorScheme: 'light' | 'dark' | 'light dark';

	projectId: string | undefined;

	/**
	 * Preferred presentation for the currently selected asset in the designer.
	 * Does not affect list thumbnails; those are always rendered in compact form.
	 */
	assetViewMode: 'view' | 'details';
}  & ChatSettingsSchema;

export const settingsInitialState: SettingsState = {
	colorScheme: 'light dark',
	// Provide empty-string defaults so form controls (non-nullable) can be initialized safely.
	projectId: undefined,
	assetViewMode: 'view',
	chatSettings: {
		imageModel: 'auto',
	},
};

export const SettingsStore = signalStore(
	{ providedIn: 'root' },
	withState(settingsInitialState),
	withMethods((store) => ({
		patch: rxMethod(
			pipe(
				tap(
					(
						...updaters: Array<
							| Partial<Prettify<SettingsState>>
							| PartialStateUpdater<Prettify<SettingsState>>
						>
					) => {
						patchState(store, ...updaters);
					}
				)
			)
		),
	})),
	withStorageSync('settings')
);
